// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"391":"210fcba4","681":"87180dee"}[chunkId] + ".chunk.css";
};